


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SequenceDiagramConfig from "./data/SequenceDiagramConfig";

@Component
export default class SequenceDiagramSimpleRenderer extends Vue {
    @Prop()
    public config!: SequenceDiagramConfig;

    protected get connections(){
        return this.config.connections;
    }

    // Note: we could use .beforeUpdate or use an explicit event or a computed property as well
    // however, this feels more explicit
    @Watch('config', { immediate: true, deep: true })
    protected onConfigChanged(newConfig: SequenceDiagramConfig, oldConfig: SequenceDiagramConfig) {
        console.log("SequenceDiagramSimpleRenderer:onConfigChanged : ", newConfig, oldConfig);
    }
} 

